export const RequirementStatus = {
    Draft: 'draft',
    WaitsApproval: 'waits_approval',
    Approved: 'approved',
    Rejected: 'rejected',
};
